"use strict";
const cookieExpiration = {
    name: "expirationTime",
    weekInMilliseconds: 15778476000,
};

const questionnaireExpiration = {
    name: "q_expirationTime",
    weekInMilliseconds: 15778476000,
};

window.addEventListener("DOMContentLoaded", () => {
    const questionnaireModal = document.querySelector("#questionnaire-modal");
    const elemOverlay = document.querySelector(".site-overlay");
    const elemBody = document.querySelector("body");
    const elemOverlayClose = document.querySelector(".site-search-header__close");
    let focusedElement;

    function controlQuestionnaireModal() {
        questionnaireModal.focus({ preventScroll: true });

        const btnOpen = document.getElementById("open-questionnaire");
        const btnClose = document.getElementById("close-modal");

        btnOpen.addEventListener("click", function(e) {
            controlQuestionnaireCookies();
        });


        btnClose.addEventListener("click", function(e) {
            e.preventDefault();
            controlQuestionnaireCookies();
        });

        focusedElement.focus({ preventScroll: false });
    }

    function isCookieExpired(cookieName) {
        const expirationStatus = localStorage.getItem(`${cookieName.name}`);

        if (Date.now() >= expirationStatus || expirationStatus === null) {
            return true;
        } else {
            return false;
        }
    }

    if (!isCookieExpired(cookieExpiration) && isCookieExpired(questionnaireExpiration)) {
        if (questionnaireModal) {
            const modalHeader = document.querySelector("#questionnaire-modal").querySelector("h3");

            questionnaireModal.classList.remove("closed");
            if (modalHeader) {
                modalHeader.setAttribute("tabindex", "0");
                modalHeader.focus({preventScroll: true});
            }

            if (elemOverlay) {
                elemOverlay.classList.add("is-active");
            }

            elemBody.classList.add("has-active-overlay");
            if (elemOverlayClose) {
                elemOverlayClose.classList.add("d-none");
            }
            focusedElement = document.activeElement;
            controlQuestionnaireModal();
        }
    }

    function controlQuestionnaireCookies() {
        localStorage.setItem(questionnaireExpiration.name, `${Date.now() + questionnaireExpiration.weekInMilliseconds}`);

        questionnaireModal.classList.add("closed");
        if (elemOverlay) {
            elemOverlay.classList.remove("is-active");
        }

        elemBody.classList.remove("has-active-overlay");
        if (elemOverlayClose) {
            elemOverlayClose.classList.remove("d-none");
        }
        focusedElement.focus({ preventScroll: false });
    }
});